import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../../button/Button';
import OutlineSuccessIcon from "../../../icons/OutlineSuccess.icon";

export const SuccessMessageContent = React.forwardRef((props, ref) => {
  const {
    message,
    onAcceptAction = () => {
      ref?.current && ref?.current.close()
    },
    title,
  } = props;

  return (
    <div style={{ width: '500px' }}>
      <div className="text-center"><OutlineSuccessIcon/></div>
      <h3 className="modal-title text-center pt-1 pb-3">{title}</h3>
      <p className="text-center">{message}</p>
      <div className="d-flex justify-content-center p-2">
        <Button className="" label="Aceptar" onClick={onAcceptAction}/>
      </div>
    </div>
  );
});

SuccessMessageContent.propTypes = {
  message: PropTypes.string,
  onAcceptAction: PropTypes.func,
  ref: PropTypes.object,
};

SuccessMessageContent.defaultProps = {
  message: 'Sus datos han sido verificados, será redireccionado al Banco para efectuar el pago.',
  title: 'Verificación de datos',
};


export default React.memo(SuccessMessageContent);
